module.exports = __webpack_public_path__ + "media/images/lb/651-0aebc3b7d605148aba7cfeb481fc8745.svg";